var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loggedInLoading)?_c('div',[_vm._v(" loading... ")]):_c('div',{staticClass:"wrapper df fdc jcc aic jcsb"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }